import { AbstractReportPmsApiService } from '../abstract-report.service';
import { PaymentReconciliation } from "../../../models/reports/daily-activity/payment-reconciliation.model";
import {PaginationCollection} from "../../../models";

/**
 * @class PaymentReconciliationPmsApiService
 * @extends {AbstractReportPmsApiService<PaymentReconciliation>}
 */
export class PaymentReconciliationPmsApiService extends AbstractReportPmsApiService {

    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {

        return super.urlPattern + '/daily-activity/payment-reconciliation';
    }

    /**
     * @param {Object.<string, *>} attributes
     * @returns {PaymentReconciliation}
     * @protected
     */
    newModel(attributes, ...params) {

        return new PaymentReconciliation(attributes);
    }

    /**
     * @param {Object.<string, *>} paginationData
     * @param {...*} params
     * @returns {PaginationCollection<M>}
     * @protected
     */
    newPaginationCollection(paginationData, ...params) {

        return {
            perPageOptions:   [ 5 ],
            perPage:          paginationData.per_page,
            page:             paginationData.current_page,
            total:            paginationData.total,
            from:             paginationData.from,
            to:               paginationData.to,
            models:           paginationData.data.map((attributes) => this.newModel(attributes, ...params)),
            amount:           paginationData.amount,
        };
    }
}



// WEBPACK FOOTER //
// ./src/pms-api/services/reports/daily-activity/payment-reconciliation.service.js